import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "tier", "iconStyle"];
import { Image } from 'foundations-components/transitional/components/Image';
import { filterProps } from 'foundations-components/utils/filterProps';
import { memo } from 'react';
import { ProductIconMap, ProductTierIconMap } from '../../constants/merchCards/ProductToIconMap';
import { jsx as _jsx } from "react/jsx-runtime";
const ProductIcon = _ref => {
  var _ProductTierIconMap$n;
  let {
      name,
      tier,
      iconStyle
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const icon = tier ? ProductTierIconMap === null || ProductTierIconMap === void 0 || (_ProductTierIconMap$n = ProductTierIconMap[name]) === null || _ProductTierIconMap$n === void 0 ? void 0 : _ProductTierIconMap$n[tier] : ProductIconMap === null || ProductIconMap === void 0 ? void 0 : ProductIconMap[name];
  const {
    domProps,
    callbackProps
  } = filterProps(rest);
  return icon ? /*#__PURE__*/_jsx(Image, Object.assign({
    src: icon,
    role: "img",
    display: "inline-block"
  }, iconStyle, domProps, callbackProps)) : null;
};
export default /*#__PURE__*/memo(ProductIcon);